<div class="v3-empty-state" [class]="'size-' + size()" [class.plain]="plain()">
  <div class="v3-empty-state__content">
    <div class="v3-empty-state__icon">
      <ptl-icon [icon]="icon()" [size]="size() === 's' ? 'm' : 'l'"></ptl-icon>
    </div>
    <h2 class="v3-empty-state__title" [attr.id]="titleId()">{{ title() }}</h2>
    @if (description()) {
      <p class="v3-empty-state__description" [attr.id]="descriptionId()">{{ description() }}</p>
    }
    <div class="v3-empty-state__cta">
      <ng-content></ng-content>
    </div>
  </div>
</div>
